import BaseReducer from "./BaseReducer";

class AccordionReducer extends BaseReducer {
  domain = "Accordion";
  type = "View";

  initialState = {
    activeAccordionIndex: [0, 1],
  };
}

const reducer = new AccordionReducer();

export default reducer;
